module.exports = __webpack_public_path__ + "media/country_flags/pf-c29e3863.png";